function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1960(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18.71,
    height: 9.15,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.7038461538461539
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 4.575
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.15,
    width: 18.71,
    height: 13.04,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1733333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 15.67
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22.19,
    width: 18.71,
    height: 13.36,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9085714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 28.87
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 35.55,
    width: 18.71,
    height: 16.26,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.322857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 43.68
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 51.81,
    width: 18.71,
    height: 17.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 60.370000000000005
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 68.93,
    width: 18.71,
    height: 21.26,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.236666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 79.56
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 90.19,
    width: 18.71,
    height: 21.62,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1183333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 101
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 111.81,
    width: 18.71,
    height: 21.87,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 122.745
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 133.68,
    width: 18.71,
    height: 28.09,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.742
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 147.725
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 161.76,
    width: 18.71,
    height: 28.55,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1183333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 176.035
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 190.31,
    width: 18.71,
    height: 28.69,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.871
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 204.655
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 219,
    width: 18.71,
    height: 30.23,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1183333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 234.115
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 249.23,
    width: 18.71,
    height: 30.94,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.672857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 264.7
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 280.18,
    width: 18.71,
    height: 33.37,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.672857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 296.865
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 313.55,
    width: 18.71,
    height: 33.87,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.672857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 330.485
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 347.43,
    width: 18.71,
    height: 34.95,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1183333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 364.90500000000003
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 382.37,
    width: 18.71,
    height: 35.73,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.33875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 400.235
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 418.11,
    width: 18.71,
    height: 36.52,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.33875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 436.37
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 454.62,
    width: 18.71,
    height: 38.09,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.672857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 473.665
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 492.72,
    width: 18.71,
    height: 39.59,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1183333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 512.515
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 532.31,
    width: 18.71,
    height: 40.84,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.33875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 552.7299999999999
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 573.15,
    width: 18.71,
    height: 42.02,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 594.16
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 615.17,
    width: 18.71,
    height: 42.09,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1183333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 636.2149999999999
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 657.26,
    width: 18.71,
    height: 42.74,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.672857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.355,
    y: 678.63
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 0,
    width: 26.31,
    height: 31,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.865000000000002,
    y: 15.5
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.01,
    y: 0,
    width: 26.46,
    height: 31,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.646
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.239999999999995,
    y: 15.5
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.47,
    y: 0,
    width: 26.85,
    height: 31,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.35625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.895,
    y: 15.5
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.32,
    y: 0,
    width: 26.89,
    height: 31,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4816666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.76499999999999,
    y: 15.5
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.21,
    y: 0,
    width: 27.67,
    height: 31,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.9175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.045,
    y: 15.5
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.88,
    y: 0,
    width: 27.93,
    height: 31,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 166.845,
    y: 15.5
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.8,
    y: 0,
    width: 28.4,
    height: 31,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.733333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195,
    y: 15.5
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.2,
    y: 0,
    width: 29.54,
    height: 31,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.22
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 223.97,
    y: 15.5
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 238.74,
    y: 0,
    width: 29.67,
    height: 31,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.238571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 253.57500000000002,
    y: 15.5
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 268.42,
    y: 0,
    width: 30,
    height: 31,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 283.42,
    y: 15.5
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.41,
    y: 0,
    width: 30.3,
    height: 31,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.0600000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 313.56,
    y: 15.5
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.71,
    y: 0,
    width: 30.38,
    height: 31,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0633333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 343.9,
    y: 15.5
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.09,
    y: 0,
    width: 32.13,
    height: 31,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.428571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 375.155,
    y: 15.5
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 391.22,
    y: 0,
    width: 32.67,
    height: 31,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.166666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.555,
    y: 15.5
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.89,
    y: 0,
    width: 33.14,
    height: 31,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.46,
    y: 15.5
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 457.04,
    y: 0,
    width: 33.38,
    height: 31,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 473.73,
    y: 15.5
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490.42,
    y: 0,
    width: 33.58,
    height: 31,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.428571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 507.21000000000004,
    y: 15.5
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 523.99,
    y: 0,
    width: 33.77,
    height: 31,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.166666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 540.875,
    y: 15.5
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 557.76,
    y: 0,
    width: 35.28,
    height: 31,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 575.4,
    y: 15.5
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.04,
    y: 0,
    width: 35.3,
    height: 31,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.428571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 610.6899999999999,
    y: 15.5
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 628.34,
    y: 0,
    width: 35.71,
    height: 31,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 646.195,
    y: 15.5
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 664.05,
    y: 0,
    width: 35.95,
    height: 31,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.428571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 682.025,
    y: 15.5
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 31,
    width: 35.59,
    height: 31.49,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.93625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 46.745
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 62.49,
    width: 35.59,
    height: 32.81,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.562
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 78.89500000000001
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 95.3,
    width: 35.59,
    height: 32.88,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.5760000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 111.74
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 128.18,
    width: 35.59,
    height: 33.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.683333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 144.755
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 161.33,
    width: 35.59,
    height: 33.54,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.791428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 178.10000000000002
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 194.87,
    width: 35.59,
    height: 34.41,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.441
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 212.075
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 229.28,
    width: 35.59,
    height: 34.59,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.918000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 246.575
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 263.87,
    width: 35.59,
    height: 34.78,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.695
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 281.26
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 298.65,
    width: 35.59,
    height: 34.95,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 316.125
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 333.6,
    width: 35.59,
    height: 35.18,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.863333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 351.19
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 368.77,
    width: 35.59,
    height: 35.55,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.44375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 386.54499999999996
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 404.33,
    width: 35.59,
    height: 35.76,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.118
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 422.21
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 440.08,
    width: 35.59,
    height: 36.17,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.118
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 458.16499999999996
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 476.25,
    width: 35.59,
    height: 36.68,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.118
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 494.59
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 512.93,
    width: 35.59,
    height: 36.72,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.954444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 531.29
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 549.65,
    width: 35.59,
    height: 37.13,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.118
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 568.215
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 586.77,
    width: 35.59,
    height: 37.43,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.9316666666666675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 605.485
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 624.2,
    width: 35.59,
    height: 37.86,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.118
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 643.13
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 662.06,
    width: 35.59,
    height: 37.94,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.9316666666666675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.505,
    y: 681.03
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 31,
    width: 35.08,
    height: 39.16,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.016
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.84,
    y: 50.58
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.37,
    y: 31,
    width: 35.18,
    height: 39.16,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.036
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.96000000000001,
    y: 50.58
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.55,
    y: 31,
    width: 35.79,
    height: 39.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.965
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 142.445,
    y: 50.58
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.35,
    y: 31,
    width: 36.15,
    height: 39.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.51875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.42499999999998,
    y: 50.58
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.5,
    y: 31,
    width: 36.83,
    height: 39.16,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.366
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.915,
    y: 50.58
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.33,
    y: 31,
    width: 37.23,
    height: 39.16,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.204999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 251.94500000000002,
    y: 50.58
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.56,
    y: 31,
    width: 37.36,
    height: 39.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4719999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 289.24,
    y: 50.58
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.92,
    y: 31,
    width: 37.94,
    height: 39.16,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.323333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.89,
    y: 50.58
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.87,
    y: 31,
    width: 38.51,
    height: 39.16,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.278888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.125,
    y: 50.58
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.38,
    y: 31,
    width: 38.59,
    height: 39.16,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.82375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 403.675,
    y: 50.58
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.97,
    y: 31,
    width: 38.66,
    height: 39.16,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.4433333333333325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.3,
    y: 50.58
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 461.63,
    y: 31,
    width: 38.76,
    height: 39.16,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 481.01,
    y: 50.58
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 500.39,
    y: 31,
    width: 39.38,
    height: 39.16,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.526666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 520.08,
    y: 50.58
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.77,
    y: 31,
    width: 39.67,
    height: 39.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.831999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 559.605,
    y: 50.58
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.44,
    y: 31,
    width: 39.84,
    height: 39.16,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.79
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 599.36,
    y: 50.58
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619.28,
    y: 31,
    width: 40.03,
    height: 39.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 639.295,
    y: 50.58
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 659.31,
    y: 31,
    width: 40.69,
    height: 39.16,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 679.655,
    y: 50.58
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 70.15,
    width: 44.06,
    height: 37,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.33,
    y: 88.65
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 107.15,
    width: 44.06,
    height: 37.11,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.422
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.33,
    y: 125.70500000000001
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 144.26,
    width: 44.06,
    height: 37.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.3028571428571425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.33,
    y: 162.82
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 181.38,
    width: 44.06,
    height: 37.14,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.33,
    y: 199.95
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 218.52,
    width: 44.06,
    height: 38.21,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.458571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.33,
    y: 237.625
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 256.73,
    width: 44.06,
    height: 39.79,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.684285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.33,
    y: 276.625
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 296.53,
    width: 44.06,
    height: 40.81,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.83
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.33,
    y: 316.93499999999995
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 337.34,
    width: 44.06,
    height: 41.29,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.258
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.33,
    y: 357.98499999999996
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 378.63,
    width: 44.06,
    height: 42.13,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.26625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.33,
    y: 399.695
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 420.76,
    width: 44.06,
    height: 42.49,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.081666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.33,
    y: 442.005
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 463.25,
    width: 44.06,
    height: 44.9,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.406000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.33,
    y: 485.7
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 508.15,
    width: 44.06,
    height: 47.53,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.812000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.33,
    y: 531.915
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 555.68,
    width: 44.06,
    height: 47.79,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.2942857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.33,
    y: 579.5749999999999
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 603.47,
    width: 44.06,
    height: 47.86,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.2942857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.33,
    y: 627.4
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 651.33,
    width: 44.06,
    height: 48.67,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.5075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.33,
    y: 675.6650000000001
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.35,
    y: 70.15,
    width: 43.77,
    height: 49.41,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.295000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.235,
    y: 94.855
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.13,
    y: 70.15,
    width: 43.92,
    height: 49.41,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.32
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.09,
    y: 94.855
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.05,
    y: 70.15,
    width: 44.65,
    height: 49.41,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.441666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 208.375,
    y: 94.855
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.7,
    y: 70.15,
    width: 44.94,
    height: 49.41,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.489999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 253.17,
    y: 94.855
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.63,
    y: 70.15,
    width: 45.02,
    height: 49.41,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.004000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 298.14,
    y: 94.855
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.65,
    y: 70.15,
    width: 45.12,
    height: 49.41,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 343.21,
    y: 94.855
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.77,
    y: 70.15,
    width: 46.21,
    height: 49.41,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.601428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 388.875,
    y: 94.855
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 411.98,
    y: 70.15,
    width: 46.33,
    height: 49.41,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.147777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 435.14500000000004,
    y: 94.855
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 458.31,
    y: 70.15,
    width: 47.32,
    height: 49.41,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.886666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 481.97,
    y: 94.855
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 505.62,
    y: 70.15,
    width: 47.57,
    height: 49.41,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.94625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 529.405,
    y: 94.855
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 553.2,
    y: 70.15,
    width: 47.69,
    height: 49.41,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.812857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 577.0450000000001,
    y: 94.855
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600.89,
    y: 70.15,
    width: 49.14,
    height: 49.41,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.0200000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 625.46,
    y: 94.855
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 650.03,
    y: 70.15,
    width: 49.97,
    height: 49.41,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.17625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.015,
    y: 94.855
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.35,
    y: 119.57,
    width: 50.11,
    height: 49.32,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.045714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.405,
    y: 144.23
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.35,
    y: 168.89,
    width: 50.11,
    height: 49.51,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.072857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.405,
    y: 193.64499999999998
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.35,
    y: 218.4,
    width: 50.11,
    height: 49.52,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.074285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.405,
    y: 243.16
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.35,
    y: 267.92,
    width: 50.11,
    height: 50.76,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.011
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.405,
    y: 293.3
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.35,
    y: 318.68,
    width: 50.11,
    height: 51.92,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.405,
    y: 344.64
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.35,
    y: 370.6,
    width: 50.11,
    height: 52.04,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.26375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.405,
    y: 396.62
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.35,
    y: 422.65,
    width: 50.11,
    height: 53.32,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.022
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.405,
    y: 449.31
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.35,
    y: 475.97,
    width: 50.11,
    height: 55.02,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.158571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.405,
    y: 503.48
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.35,
    y: 530.99,
    width: 50.11,
    height: 55.86,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.158571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.405,
    y: 558.92
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.35,
    y: 586.84,
    width: 50.11,
    height: 56.52,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.5275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.405,
    y: 615.1
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.35,
    y: 643.37,
    width: 50.11,
    height: 56.63,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.022
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.405,
    y: 671.6850000000001
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.47,
    y: 119.57,
    width: 51.07,
    height: 55.8,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.214
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 174.005,
    y: 147.47
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.53,
    y: 119.57,
    width: 51.28,
    height: 55.8,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.546666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.17000000000002,
    y: 147.47
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250.82,
    y: 119.57,
    width: 52.27,
    height: 55.8,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.711666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.955,
    y: 147.47
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.08,
    y: 119.57,
    width: 52.55,
    height: 55.8,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.1375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.35499999999996,
    y: 147.47
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 355.63,
    y: 119.57,
    width: 55.12,
    height: 55.8,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.186666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 383.19,
    y: 147.47
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410.75,
    y: 119.57,
    width: 55.73,
    height: 55.8,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.96625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 438.615,
    y: 147.47
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 466.48,
    y: 119.57,
    width: 57.07,
    height: 55.8,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.16
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 495.01500000000004,
    y: 147.47
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 523.55,
    y: 119.57,
    width: 57.94,
    height: 55.8,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.299999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 552.52,
    y: 147.47
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 581.49,
    y: 119.57,
    width: 58.45,
    height: 55.8,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.971428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 610.715,
    y: 147.47
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 639.94,
    y: 119.57,
    width: 60.06,
    height: 55.8,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.299999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.97,
    y: 147.47
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.47,
    y: 175.36,
    width: 59.61,
    height: 59.23,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.5811111111111105
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.275,
    y: 204.97500000000002
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.47,
    y: 234.59,
    width: 59.61,
    height: 60.76,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.45125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.275,
    y: 264.97
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.47,
    y: 295.35,
    width: 59.61,
    height: 61.8,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.935
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.275,
    y: 326.25
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.47,
    y: 357.14,
    width: 59.61,
    height: 64.93,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.515714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.275,
    y: 389.605
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.47,
    y: 422.07,
    width: 59.61,
    height: 68.2,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.45125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.275,
    y: 456.17
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.47,
    y: 490.27,
    width: 59.61,
    height: 68.37,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.9025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.275,
    y: 524.4549999999999
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.47,
    y: 558.64,
    width: 59.61,
    height: 69.29,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.45125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.275,
    y: 593.285
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.47,
    y: 627.93,
    width: 59.61,
    height: 72.07,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.515714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.275,
    y: 663.9649999999999
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.07,
    y: 175.36,
    width: 63.72,
    height: 68.28,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.744
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.93,
    y: 209.5
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.79,
    y: 175.36,
    width: 63.75,
    height: 68.28,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.107142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 303.665,
    y: 209.5
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.55,
    y: 175.36,
    width: 63.94,
    height: 68.28,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.134285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 367.52,
    y: 209.5
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 399.48,
    y: 175.36,
    width: 69.13,
    height: 68.28,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.38
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.045,
    y: 209.5
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.61,
    y: 175.36,
    width: 71.79,
    height: 68.28,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.07
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 504.505,
    y: 209.5
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 540.4,
    y: 175.36,
    width: 75.88,
    height: 68.28,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.586666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 578.3399999999999,
    y: 209.5
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 616.28,
    y: 175.36,
    width: 83.72,
    height: 68.28,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.656
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 658.14,
    y: 209.5
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.07,
    y: 243.64,
    width: 84.6,
    height: 67.89,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.315
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.37,
    y: 277.585
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.07,
    y: 311.53,
    width: 84.6,
    height: 69.64,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.705
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.37,
    y: 346.34999999999997
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.07,
    y: 381.18,
    width: 84.6,
    height: 69.88,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.982857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.37,
    y: 416.12
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.07,
    y: 451.06,
    width: 84.6,
    height: 69.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.764444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.37,
    y: 486
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.07,
    y: 520.94,
    width: 84.6,
    height: 72.73,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.1825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.37,
    y: 557.3050000000001
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.07,
    y: 593.67,
    width: 84.6,
    height: 106.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.919999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.37,
    y: 646.8349999999999
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.67,
    y: 243.64,
    width: 120.83,
    height: 100.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.5375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 353.08500000000004,
    y: 293.78999999999996
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 413.5,
    y: 243.64,
    width: 140.92,
    height: 100.3,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 483.96,
    y: 293.78999999999996
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 554.42,
    y: 243.64,
    width: 145.58,
    height: 100.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.5375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 627.2099999999999,
    y: 293.78999999999996
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.67,
    y: 343.94,
    width: 110.91,
    height: 150.11,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.7275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 348.125,
    y: 418.995
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.67,
    y: 494.05,
    width: 110.91,
    height: 205.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.844285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 348.125,
    y: 597.025
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.58,
    y: 343.94,
    width: 296.42,
    height: 108.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.099999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 551.79,
    y: 398.24
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.58,
    y: 452.54,
    width: 296.42,
    height: 247.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 41.24333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 551.79,
    y: 576.27
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1960);
export default __webpack_public_path__ + "static/media/1960.3c1e5d5416081c40adcdc3cbe3a72a0f.svg";
export { ForwardRef as ReactComponent };